import React, { Component } from "react";
import Navbar from "../Navbars/Navbar";
import Footer from "components/Footers/Footer";
import "assets/css/safexpay-web.css";
import "../Policy/Policy.css";

export default class Disclaimer extends Component {
  render() {
    return (
      <>
        <Navbar />
        <main ref="main" className="dv-main">
          <section
            className="dv-HeroBanner dv-Policy"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="herobanner-heading text-center pt-5 font-w6">
              Disclaimer
            </h1>
          </section>
          <section className="dv-Policy-content">
            <div
              className="container"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="row">
                <div className="col-12">
                  <p className="font-s19">
                    Safexpay has taken care to ensure that all content,
                    software, functions, materials, and information made
                    available on, provided in connection with or accessible
                    through on this website is accurate, this website and the
                    services accessible on or via this website are provided "as
                    is" and “as available” basis and your use of and reliance on
                    the information on this website and the online services is
                    entirely at your own risk. Safexpay makes no representation
                    or warranty of any kind whatsoever for the website,
                    software, advice & opinions, post, any tools, statements,
                    information, content or online services will be error-free
                    or viruses or any other harmful component will meet any
                    particular criteria of accuracy, completeness, reliability,
                    performance or quality. Safexpay does not warrant or
                    represent regarding any content provided through this
                    website and disclaims its liabilities in respect thereof. We
                    reserve the right, in our sole discretion, to correct any
                    errors or omissions in any portion of this website. While
                    Safexpay takes all reasonable precautions to prevent this,
                    we do not warrant that the website or any software available
                    for download via the website is free of viruses or
                    destructive code. To the fullest extent permissible by law,
                    Safexpay expressly disclaims all (express and implied)
                    warranties, including, without limitation, warranties of
                    merchantability, title, and fitness for a particular
                    purpose, noninfringement, compatibility, security and
                    accuracy, damages for loss of profits, business
                    interruption, loss of programs or information in respect of
                    this website and the services accessible on this website.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }
}
